import ApplicationModel, { attr } from '../ApplicationModel';
import { type LineBreakAttributes } from './generated/LineBreakAttributes';
import { model } from '../modelBuilder';
import { JsonQuerySerialization } from './concerns/JsonQuerySerialization';

interface LineBreak extends LineBreakAttributes {}

@model
@JsonQuerySerialization
class LineBreak extends ApplicationModel {
  // Start auto-generated
  static typename: 'LineBreak' = 'LineBreak';
  get typename(): 'LineBreak' {
    return 'LineBreak';
  }

  static fields = {
    rank: attr({ readable: true }),
    title: attr({ readable: true }),
  };
  // End auto-generated

  /**
   * title is readonly in the graphql schema, but we need to be able to set it
   * for writing in the parent record
   */
  set title(title: string) {
    this.setAttribute('title', title);
  }
}

export default LineBreak;
